import { useState } from 'react';
import './flightbooking.css'; // You might want to rename this to hotelbooking.css later

const HotelReservation = (props) => {
  const { isOpen, setIsOpen } = props;
  
  // State variables updated for Hotel context
  const [destination, setDestination] = useState('');
  const [checkInDate, setCheckInDate] = useState('');
  const [checkOutDate, setCheckOutDate] = useState('');
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [rooms, setRooms] = useState(1);

  // Mock destinations (Simplified for Hotel search)
  // const locations = [
  //   "Karachi, Pakistan", "Lahore, Pakistan", "Islamabad, Pakistan", 
  //   "Dubai, UAE", "London, UK", "New York, USA", "Toronto, Canada"
  // ];

  const handleSearchHotels = (e) => {
    e.preventDefault();
    
    const reservationDetails = {
      destination,
      checkInDate,
      checkOutDate,
      adults,
      children,
      rooms
    };

    console.log('Hotel Reservation Details:', reservationDetails);
    setIsOpen(false);
  };

  return (
    <div className="container">
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">
                <div className="modal-title-icon" aria-hidden="true">
                  <i className="fa fa-hotel" />
                </div>
                <div className="modal-title-text">
                  <h2>Hotel Reservation</h2>
                  <p>Find and book your stay in a few clicks.</p>
                </div>
              </div>
              <button type="button" className="close-x" aria-label="Close" onClick={() => setIsOpen(false)}>&times;</button>
            </div>

            <form className="flight-form" onSubmit={handleSearchHotels}>

              <div className="form-section">
                {/* Destination Selection */}
                <div className="form-row">
                  <div className="input-group" style={{ width: '100%' }}>
                    <label><i className="fa fa-map-marker-alt" aria-hidden="true" /> Destination</label>
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Where are you going?"
                      value={destination}
                      onChange={(e) => setDestination(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* Dates */}
                <div className="form-row">
                  <div className="input-group">
                    <label><i className="fa fa-calendar-alt" aria-hidden="true" /> Check-in Date</label>
                    <input
                      type="date"
                      className="form-input"
                      value={checkInDate}
                      min={new Date().toISOString().split('T')[0]}
                      onChange={(e) => setCheckInDate(e.target.value)}
                      required
                    />
                  </div>
                  <div className="input-group">
                    <label><i className="fa fa-calendar-alt" aria-hidden="true" /> Check-out Date</label>
                    <input
                      type="date"
                      className="form-input"
                      value={checkOutDate}
                      min={checkInDate || new Date().toISOString().split('T')[0]}
                      onChange={(e) => setCheckOutDate(e.target.value)}
                      required
                    />
                  </div>
                </div>

                {/* Guests and Rooms */}
                <div className="form-row">
                  <div className="input-group">
                    <label><i className="fa fa-user" aria-hidden="true" /> Adults</label>
                    <select
                      className="form-input"
                      value={adults}
                      onChange={(e) => setAdults(e.target.value)}
                    >
                      {[1, 2, 3, 4, 5].map(num => <option key={num} value={num}>{num}</option>)}
                    </select>
                  </div>
                  <div className="input-group">
                    <label><i className="fa fa-child" aria-hidden="true" /> Children</label>
                    <select
                      className="form-input"
                      value={children}
                      onChange={(e) => setChildren(e.target.value)}
                    >
                      {[0, 1, 2, 3, 4].map(num => <option key={num} value={num}>{num}</option>)}
                    </select>
                  </div>
                  <div className="input-group">
                    <label><i className="fa fa-door-closed" aria-hidden="true" /> Rooms</label>
                    <select
                      className="form-input"
                      value={rooms}
                      onChange={(e) => setRooms(e.target.value)}
                    >
                      {[1, 2, 3, 4].map(num => <option key={num} value={num}>{num}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={() => setIsOpen(false)}>
                  Cancel
                </button>
                <button type="submit" className="search-btn">
                  <i className="fa fa-search" aria-hidden="true" />  Submit Inquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default HotelReservation;